/* =============================================
   JER マッチングシステム - 共通JavaScript
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // =============================================
  // モバイルメニュー
  // =============================================
  const menuBtn = document.getElementById('menuBtn');
  const sidebar = document.getElementById('sidebar');
  const overlay = document.getElementById('overlay');

  if (menuBtn && sidebar && overlay) {
    menuBtn.addEventListener('click', function () {
      const isOpen = sidebar.classList.toggle('mobile-open');
      overlay.classList.toggle('active', isOpen);
      menuBtn.classList.toggle('is-open', isOpen);
      menuBtn.setAttribute('aria-expanded', isOpen);
    });

    overlay.addEventListener('click', function () {
      sidebar.classList.remove('mobile-open');
      overlay.classList.remove('active');
      menuBtn.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
    });
  }

  // =============================================
  // TOPへ戻るボタン（スクロール時のみ表示）
  // =============================================
  const backToTop = document.querySelector('.back-to-top');
  if (backToTop) {
    backToTop.style.opacity = '0';
    backToTop.style.transition = 'opacity 0.3s';
    backToTop.style.pointerEvents = 'none';

    window.addEventListener('scroll', function () {
      if (window.scrollY > 300) {
        backToTop.style.opacity = '1';
        backToTop.style.pointerEvents = 'auto';
      } else {
        backToTop.style.opacity = '0';
        backToTop.style.pointerEvents = 'none';
      }
    });

    backToTop.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // =============================================
  // ページネーション（デモ用クリック処理）
  // =============================================
  document.querySelectorAll('.pagination a').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.classList.contains('disabled')) return;
      document.querySelectorAll('.pagination a').forEach(function (a) {
        a.classList.remove('active');
      });
      if (!this.textContent.includes('‹') && !this.textContent.includes('›')) {
        this.classList.add('active');
      }
    });
  });

  // =============================================
  // 記事アイテム：クリック全体にリンク適用
  // =============================================
  document.querySelectorAll('.article-item[href]').forEach(function (item) {
    item.addEventListener('click', function () {
      window.location.href = this.getAttribute('href');
    });
  });

});
